module.exports = __webpack_public_path__ + "static/media/upload.b1dd6d07.svg";